import { TableParams } from '@/@types/common';
import { DEFAULT_TABLE_PARAMS } from '@/constants/config';
import { usePersistFn } from 'ahooks';
import _ from 'lodash';
import { useMemo, useState } from 'react';

function useTable(
  updateParamsCb?: (params: TableParams) => void,
  defaultParams?: BaseObject<any>,
) {
  const [prevParams, setPrevParams] = useState({ ...defaultParams, ...DEFAULT_TABLE_PARAMS });

  const params = useMemo(() => {
    return { ...DEFAULT_TABLE_PARAMS, ...defaultParams }
  }, [defaultParams])

  /**
   * 更新params，始终带上默认的参数
   */
  const updateParams = usePersistFn((newParams = {}) => {
    const nextParams = {
      ...params,
      ...newParams,
    };
    updateParamsCb?.(nextParams);
    setPrevParams(nextParams);
  });

  /**
   * 保留上一次查询参数，这里为了保留form参数
   */
  const onChange = usePersistFn((newParams) => {
    // 如果是事件对象则为空
    if (newParams.preventDefault) newParams = {};

    updateParams({
      ...prevParams,
      ...newParams,
    });
  })

  /**
   * form搜索函数
   * 需要重置 page = 1
   */
  const handleTableSearch = usePersistFn((params = {}) => {
    if (params.preventDefault) params = {};
    updateParams({ ...params, page: 1 })
  });

  const onRefresh = usePersistFn(() => {
    updateParamsCb(prevParams)
  })

  return {
    params,
    prevParams,
    onRefresh,
    onChange,
    onSearch: handleTableSearch,
  };
}

export default useTable;
